import React from "react";
import { Link } from "react-router-dom";
import HeaderCities from "../components/HeaderCities";
import ContactForm from "../components/ContactForm";
import "../assets/css/location.css";

function Locations() {
  return (
    <div>
      <head>
        <meta
          name="description"
          content="Discover Junk Droid’s service areas for professional junk removal. We provide fast, eco-friendly hauling. Check if we serve your location!"
        />
        <link rel="canonical" href="https://junkdroid.com/locations/" />
        <title>Junk Droid Service Locations | Find Junk Removal Near You</title>
      </head>
      <>
        <HeaderCities />
        {/* ============= Areas we Work Section Start Here ==================== */}
        <div className="container-fluid pricing-removal-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <div className="removal-sec section-area">
                  <h1 className="area-head">Areas We Serve</h1>
                  <div className="sliderline-svg removal-svg price-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={64}
                      height={4}
                      viewBox="0 0 64 4"
                      fill="none"
                    >
                      <path
                        d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                        fill="#60BDFF"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-md-5 btn-section">
                <a href="https://online-booking.workiz.com/?ac=2f3063010df7315df866536f0fa1a1f46be816ae2841d0100103eb5b69cf328f">
                  <button type="button" className="btn removal-btn rmv-btn">
                    Book Appointment &nbsp;
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* ============= Areas we Work Section End Here ==================== */}
        {/* ============= California Country Section End Here ==================== */}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="country-head-sec">
                <h2>
                  California <br />
                  <span>Santa Clara County</span>
                </h2>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#4CA5E4"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="row countries-sec">
            <div className="col-xl-4 col-lg-4 col-md-6 location-sec map-sec-li">
              <Link to="/campbellca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="Location Pin" />
                  <span>Campbell</span>
                </li>
              </Link>
              <Link to="/cupertinoca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Cupertino</span>
                </li>
              </Link>
              <Link to="/fremontca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Fremont</span>
                </li>
              </Link>
              <Link to="/losaltosca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Los Altos</span>
                </li>
              </Link>
              <Link to="/losgatosca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Los Gatos</span>
                </li>
              </Link>
            </div>
            {/*  */}
            <div className="col-xl-4 col-lg-4 col-md-6 location-sec map-sec-li">
              <Link to="/milpitasca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Milpitas</span>
                </li>
              </Link>

              <Link to="/mountainviewca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Mountain View</span>
                </li>
              </Link>
              <Link to="/newarkca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Newark</span>
                </li>
              </Link>
              <Link to="/paloaltoca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Palo Alto</span>
                </li>
              </Link>
              <Link to="/sanjoseca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>San Jose</span>
                </li>
              </Link>
            </div>
            {/*  */}
            <div className="col-xl-4 col-lg-4 col-md-6 location-sec map-sec-li">
              <Link to="/saratogaca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Saratoga</span>
                </li>
              </Link>
              <Link to="/santaclaraca/">
                <li>
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Santa Clara</span>
                </li>
              </Link>
              <Link to="/sunnyvaleca/">
                <li className="pb-0">
                  <img src="/assets/img/map-pin.svg" alt="" />
                  <span>Sunnyvale</span>
                </li>
              </Link>
            </div>
            {/*  */}
            <div className="col-xl-3 col-lg-4 col-md-6 location-sec map-sec-li"></div>
          </div>
        </div>
        {/* ============= California Country Section End Here ==================== */}
        {/* ================== Contact Form  Section End HERE =========================  */}
        <div className="container-fluid about-sec">
          <div className="container junk-container about-sec-inner">
            <div className="row">
              <div className="col-md-12 removalprocess-sec getrid-sec">
                <h2>Get a Free Quote</h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p className="contact-det p-0">
                  Call us 7 days a Week 8 a.m to 8 p.m
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="contact-form-section form-section">
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ================== Contact Form Cards  Section End HERE =========================  */}
      </>
    </div>
  );
}

export default Locations;
